module.exports = require("@swa-ui/core/src/VerticalList/VerticalList.module.scss");